/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_EurobydleniInputs */

const cs_enum_eurobydleni = /** @type {(inputs: Enum_EurobydleniInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eurobydlení`)
};

const en_enum_eurobydleni = /** @type {(inputs: Enum_EurobydleniInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eurobydleni`)
};

/**
* | output |
* | --- |
* | "Eurobydleni" |
*
* @param {Enum_EurobydleniInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_eurobydleni = /** @type {((inputs?: Enum_EurobydleniInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_EurobydleniInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_eurobydleni(inputs)
	return cs_enum_eurobydleni(inputs)
});